import { QueryClient, QueryKey } from '@tanstack/react-query'

import {
  getPresenceQueryKey,
  Presence
} from '../../hooks/queries/usePresenceQuery'

export const basePresenceQueryKey = ['ws', 'presence']

export function setPersonaPresence(
  {
    personaId,
    presence
  }: {
    personaId: string
    presence: Presence
  },
  queryClient: QueryClient
) {
  queryClient.setQueryData<
    Presence | null | undefined,
    QueryKey,
    Presence | null
  >(getPresenceQueryKey(personaId), presence)
}
